import React, { useEffect, useMemo } from 'react';
import { Checkbox } from 'tea-component';
import { connect } from 'umi';
import BubbleCommon, { TipsMapType } from '@op/components/BubbleCommon';
import { IDispatchToProps } from '../../types';
import { singleMapStateToProps, checkboxMergeProps } from '../../connect/single';
import useIntls from '@opm/hooks/useIntls';
import './index.scss';

export type CheckboxFilterType = {
  label: string;
  labelCn: string;
  tipsMap?: TipsMapType;
  /** The filter key to watch for enabling/disabling the checkbox */
  dependencyKey?: string;
  /** Values that indicate "all" is selected (checkbox should be disabled) */
  allValues?: string[];
} & IDispatchToProps;

export function CheckboxFilter({
  value,
  change,
  filterValue,
  label,
  labelCn,
  tipsMap,
  dependencyKey,
  allValues = ['all', 'global'],
}: CheckboxFilterType & {
  value: boolean;
  change: (value: boolean) => void;
  filterValue: any;
}) {
  const { isEn } = useIntls();

  const isDisabled = useMemo(() => {
    if (!dependencyKey) return false;
    const depValue = filterValue?.[dependencyKey as string];
    if (!depValue || !Array.isArray(depValue)) return true;
    if (depValue.length === 0) return true;
    return depValue.some((v: string) => allValues.includes(v));
  }, [filterValue, dependencyKey, allValues]);

  // Auto-uncheck when disabled
  useEffect(() => {
    if (isDisabled && value) {
      change(false);
    }
  }, [isDisabled, value, change]);

  return (
    <div className="dbom-checkbox-filter-wrapper">
      <BubbleCommon placement="top" tipsMap={tipsMap} showIcon={false} >
        <Checkbox
          disabled={isDisabled}
          value={value}
          onChange={(checked) => change(checked)}
        >
          {isEn ? label : labelCn}
        </Checkbox>
      </BubbleCommon>
    </div>
  );
}

export default connect(
  singleMapStateToProps,
  checkboxMergeProps,
)(CheckboxFilter);
